import { Checkbox } from "@material-ui/core";
import dayjs from "dayjs";
import React, { Component } from "react";
import { isNullOrUndefined } from "util";
import { s360ConfigService } from "../../Services/S360Config";

export default class MessageA98 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name:"",
      value: "",
      actionDone: false,
      options: this.props.entry.text_data.options,
    };
  }
  componentDidMount() {
    this.setState({ options: this.formatData(this.state.options) });
  }
  formatData = function (data) {
    let temp = [];
    for (let i = 0; i < data.length; i++) {
      data[i].disabled = false;
      temp.push(data[i]);
    }
    console.log(data);
    return temp;
  };
  // data = {
  //   options: [
  //     {
  //       name: "A",
  //       value: "a",
  //     },
  //     {
  //       name: "B",
  //       value: "b",
  //     },
  //   ],
  // };
  // hardLimit = this.data.hardlimit;
  // checkOptions = this.data.options;

  onChangeHandler = (event) => {
    console.log(event.target.value)
    this.setState({ value: event.target.value,
      name:event.target.name,
     });
  };
  onSubmit = () => {
    this.props.actions.sendMessageWithCode(
      this.props.entry.keyword,

      {
        name: this.state.name.trim(),
        value: this.state.value.trim(),
      }
    );
    var n = document.getElementsByClassName(
      "s360-message-box-custom-a15-received"
    );
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // this.onMouseLeave({ "target": n[i]});
    }
    var a = document.getElementsByClassName("oneCheckOption");
    for (var i = 0; i < a.length; i++) {
      a[i].style.pointerEvents = "none";
      a[i].style.opacity = "0.5";
    }
  };
  messageBoxSubmitStyle = () => {
    const designDetials = s360ConfigService.config.designDetails;
    let styleData = {
      // background: s360ConfigService.config.designDetails.recieverMessageColor,
      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
      // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
      marginLeft: "15px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: isNullOrUndefined(designDetials.buttonBorderColor)
        ? "#0092ed"
        : designDetials.buttonBorderColor,

      borderRadius: isNullOrUndefined(designDetials.buttonBorderRadius)
        ? 20
        : designDetials.buttonBorderRadius,
      color: isNullOrUndefined(designDetials.buttonTextColor)
        ? "#0092ed"
        : designDetials.buttonTextColor,
      backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor)
        ? "#fff"
        : designDetials.buttonBackgroundColor,
      fontWeight: isNullOrUndefined(designDetials.senderFontWeight) ? 500 : 500,
    };
    return styleData;
    // return {
    //     background: s360ConfigService.config.designDetails.recieverMessageColor,
    //      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont,
    //      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize,
    //      color: s360ConfigService.config.designDetails.recieverMessageFontColor,
    //      marginLeft: '15px'
    //     }
  };
  render() {
    console.log(this.props.entry.text_data.options, "props check");
    return (
      <div className="CheckBoxWithSubmit">
        <div className="CheckBoxContainer">
          {this.state.options.length === 0 ? (
            <p>No Options to display</p>
          ) : (
            this.state.options.map((oneOption) => (
              <div
                className={"oneCheckOption"}
                style={{ border: "1px solid #DE0000" }}
              >
                <input
                  type="radio"
                  style={{ margin: "0px 10px" }}
                  value={oneOption.value}
                  name={oneOption.name}
                  onChange={this.onChangeHandler}
                  checked={this.state.value?.trim() === oneOption.value?.trim()}
                ></input>
                {oneOption.name}
              </div>
            ))
          )}
        </div>
        {this.props.isLastEntry && this.props.sentTimestamp && (
          <div
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs.unix(this.props.sentTimestamp).format("DD MMM h:mm a")}
          </div>
        )}
        <div className="s360-message-cotainer-received">
          <button
            // disabled={this.state.actionDone}
            disabled={this.props.disabled}
            className="s360-message-box-custom-a15-received"
            onClick={
              this.state.value.length === 0
                ? console.log("not selected")
                : this.onSubmit
            }
            onMouseEnter={this.onMouseEnterButton}
            onMouseLeave={this.onMouseLeaveButton}
            style={this.messageBoxSubmitStyle()}
          >
            {this.props.entry.data
              ? JSON.parse(this.props.entry.data).buttonText
              : "Submit"}
          </button>
        </div>
      </div>
    );
  }
}
